<template>
  <RouterView/>
</template>

<script setup>
import {RouterView} from 'vue-router'
import {onBeforeMount} from 'vue'
import {useAppStore} from './store/app.js'

onBeforeMount(() => {
  const app = useAppStore()
  console.log('store', app)
})

</script>

<style scoped>

</style>
